<template>
  <li class="list-item">
    <NuxtLink :to="$localePath(`/review/${review.id}?${queryString}`)" class="list-link">
      <div class="thum" :class="{ default: review.thumbnailUrl == null }">
        <div class="thum-img" :style="{ backgroundImage: `url(${review.thumbnailUrl ?? defaultThumbnail})` }" />
      </div>
      <div class="info">
        <div class="post-title" v-html="review.title" />
        <div class="post-excerpt" v-html="review.contents" />
        <div class="post-info">
          <span v-if="!my" class="user">{{ review.writerNm }}, {{ review.countryNm }}</span>
          <div class="detail">
            <div class="date">
              {{ formatIntlDate(new Date(review.createdAt), locale) }}
            </div>
            <div v-if="!my" class="view">
              <i class="ico ico-smile" />{{ formatNumber(review.viewCnt, locale) }}
            </div>
            <div v-if="!my" class="comment">
              <i class="ico ico-reply" />{{ formatNumber(review.commentCnt, locale) }}
            </div>
            <div v-if="!my" class="like">
              <i class="ico ico-heart-round" />{{ formatNumber(review.likeCnt, locale) }}
            </div>
          </div>
          <div v-if="my && !review.openYn" class="status waiting">
            {{ $t('대기') }}
          </div>
          <!-- <div class="status open" v-if="my && review.openYn">{{ $t('공개') }}</div> -->
        </div>
      </div>
    </NuxtLink>
  </li>
</template>

<script setup lang="ts">
defineProps<{
  review: Review
  my: boolean
}>()
const { locale } = useI18n()

const route = useRoute()
const queryString = route.fullPath.split('?')[1] ?? ''

const { defaultThumbnail } = useReview()
</script>
